// extracted by mini-css-extract-plugin
export default {"root":"DroppableCell_root__ftQcT","isActive":"DroppableCell_isActive__bD+PC"};